import { render, staticRenderFns } from "./ReportCollectionStatus.vue?vue&type=template&id=1364e988&scoped=true&"
import script from "./ReportCollectionStatus.vue?vue&type=script&lang=js&"
export * from "./ReportCollectionStatus.vue?vue&type=script&lang=js&"
import style0 from "./ReportCollectionStatus.vue?vue&type=style&index=0&id=1364e988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364e988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
